// @flow
import styled from "styled-components"
import { HPaddedFullWidthContainer } from "componentsStyled/Layout/Containers"

export const MainNavWrap = styled(HPaddedFullWidthContainer)`
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
  display: flex;
  align-items: center;
  height: 6.4rem;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/styled.js